import { Tag } from 'antd';
import FilterInput from "components/Form/filterInput";
import { useCallback, useEffect, useState } from "react";

import { Button } from "components/Button";
import { format } from "date-fns";
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";
import { activeStatusOptions, eosOptions, genderOptions, maritalStatusOptions } from "utils/constants";

const FILTER_LABELS = {
  employment_date_after: "Joined after",
  employment_date_before: "Joined before",
  resigned_date_after: "Resigned after",
  resigned_date_before: "Resigned before",
  gender: "Gender",
  report_to: "Report to",
  department: "Department",
  nationality: "Nationality",
  position: "Designation",
  division: "Division",
  marital_status: "Marital Status",
  cost_center: "Cost Center",
  status: "Status",
  eos_approved: "End of Service",
};

const formatDateValue = (raw) => {
  try {
    return format(new Date(raw), "dd/MM/yyyy")
  } catch (e) {
    return raw
  }
}
const EmployeeListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading, appliedFilterCount, handleExport, exportLoading}) => {
  const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading
    
} = useSelector((state) => state.common);
const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{

    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading ){

      const resolveValue = (key, raw) => {
        switch(key){
          case "employment_date_after":
          case "employment_date_before":
          case "resigned_date_after":
          case "resigned_date_before":
            return formatDateValue(raw)
          case "gender":
            return genderOptions.find(opt => String(opt.value) === String(raw))?.label || toTitleCase(raw)
          case "marital_status":
            return maritalStatusOptions.find(opt => String(opt.value) === String(raw))?.label || toTitleCase(raw)
          case "status":
            if(raw === "all") return "All"
            return activeStatusOptions.find(opt => String(opt.value) === String(raw))?.label || toTitleCase(raw)
          case "eos_approved":
            return eosOptions.find(opt => String(opt.value) === String(raw))?.label || toTitleCase(raw)
          case "report_to": {
            const selected = reportTo?.find(r => String(r.user_id) === String(raw))
            return selected ? `${selected.first_name} ${selected.last_name || ""}`.trim() : raw
          }
          case "department":
            return department?.find(d => String(d.id) === String(raw))?.name || raw
          case "position":
            return position?.find(p => String(p.id) === String(raw))?.name || raw
          case "division":
            return division?.find(d => String(d.id) === String(raw))?.name || raw
          case "cost_center": {
            const selected = costCenter?.find(cc => String(cc.id) === String(raw))
            return selected?.name || selected?.code || raw
          }
          case "nationality": {
            const ids = String(raw).split(",").map(id => id.trim()).filter(Boolean)
            const names = nationality?.filter(n => ids.includes(String(n.id))).map(n => n.name)
            return names?.length ? names.join(", ") : raw
          }
          default:
            return String(raw)
        }
      }

      const _appliedFilters = Object.keys(FILTER_LABELS)
        .map(key => {
          const raw = searchParams.get(key) || ""
          if(!raw) return null
          return { key, label: FILTER_LABELS[key], value: resolveValue(key, raw) }
        })
        .filter(Boolean)

      setAppliedFilters(_appliedFilters)
    }

  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    costCenter,
    departmentLoading,
    reportToLoading,
    nationalityLoading,
    positionLoading,
    divisionLoading,
    searchParams,
  ])



  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "employment_date_after" || item.key == "employment_date_before"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div className="mb-4">
      <div className="row align-items-center g-3">
        <div className="col-lg-9 col-md-12">
          <div className="row g-3">
            <div className='col-sm-12 col-lg-4'>
              <FilterInput  
                defaultValue={setInputValue("search")} 
                onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
                id="search"
                label={searchPlaceholder}
              />
            </div>
            <div className='col-sm-12 col-lg-8 d-flex flex-wrap align-items-center gap-2'>
              {appliedFilters.map((item) => (
                <Tag
                  key={item.key}
                  icon={loading && <i className="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>}
                  className="mb-0"
                  color="#D3001A"
                  style={{
                    borderRadius: "6px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: "500",
                    border: "none"
                  }}
                  closeIcon={<i className="fa fa-times" style={{ fontSize: "11px" }}></i>}
                  onClose={e=>handleClose(e, item)}
                >
                  <span style={{ opacity: 0.8 }}>{item.label}:</span> {item.value}
                </Tag>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-12 d-flex justify-content-end gap-2">
          <Button
            className="btn btn-primary shadow-sm"
            style={{ borderRadius: "8px" }}
            icon={"fa fa-download"}
            loading={exportLoading}
            onClick={handleExport}
          />
          <div className="position-relative">
            <Button
              onClick={handleFilterDrawer}
              icon="las la-filter"
              className="btn btn-outline-secondary shadow-sm"
              style={{ borderRadius: "8px" }}
            />
            {appliedFilterCount > 0 && (
              <span 
                className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill"
                style={{ fontSize: "10px", padding: "2px 6px" }}
              >
                {appliedFilterCount}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListFilter;
